import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import dayjs from "dayjs";
import enUS from "date-fns/locale/en-US";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import calendarIcon from "../../resources/icons/calendar.svg"; 

interface Props {
  onChange: (start: string, end: string) => void;
}

const DateRangePicker: React.FC<Props> = ({ onChange }) => {
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleSelect = (ranges: any) => {
    const { startDate, endDate } = ranges.selection;
    setRange([ranges.selection]);
    onChange(
      dayjs(startDate).format("YYYY-MM-DD"),
      dayjs(endDate).format("YYYY-MM-DD")
    );
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const display = dayjs(range[0].startDate).isSame(range[0].endDate, "day")
    ? `${dayjs(range[0].startDate).format("YYYY-MM-DD")}`
    : `${dayjs(range[0].startDate).format("YYYY-MM-DD")} → ${dayjs(range[0].endDate).format("YYYY-MM-DD")}`;

  return (
    <div className="relative w-[20rem]" ref={wrapperRef}>
      <span className="absolute left-3 top-1/2 -translate-y-1/2">
        <img src={calendarIcon} alt="Calendar" className="w-4 h-4" />
      </span>
      <input
        readOnly
        onClick={() => setOpen(!open)}
        value={display}
        className="pl-10 pr-3 py-2 w-full rounded-md border border-[#D0D5DD] bg-white  text-sm cursor-pointer text-[#667085]"
        placeholder="Select date range"
      />
      {open && (
        <div className="absolute z-50 bg-white shadow-lg mt-2">
          <DateRange
            editableDateInputs={true}
            onChange={handleSelect}
            moveRangeOnFirstSelection={false}
            ranges={range}
            showDateDisplay={false}
            rangeColors={["#3B82F6"]}
            locale={enUS}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangePicker;
